import React from "react";
// import FormProgress from "../UnitAdmin/FormProgress";
import FormProgress from "../AuditAdmin/FormProgress";
import SendBackGapAssesmentAccordion from "./SendBackGapAssesmentAccordion";

const SendBackGapAseesment = ({version}) => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Gap Assessment</div>
        <SendBackGapAssesmentAccordion version={version}/>
      </div>
    </>
  );
};

export default SendBackGapAseesment;
